var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnerLookup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 80,
    viewBox: "0 0 68 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 4,
    rx: 2,
    fill: "#AFB8C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#AFB8C1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#AFB8C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#54AEFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 24,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#54AEFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 60,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#AFB8C1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 68,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#AFB8C1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 76,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnerLookup);
export default __webpack_public_path__ + "static/media/inner-lookup.a00f4b350333fd2e2546f216a926c44b.svg";
export { ForwardRef as ReactComponent };